import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import AppHeaderCheckout from 'modules/AppHeaderCheckout'
import CheckoutSteps from 'modules/Checkout/CheckoutSteps'
import Checkout0 from 'modules/Checkout/Checkout0'
import Checkout1 from 'modules/Checkout/Checkout1'
import Checkout2 from 'modules/Checkout/Checkout2'
import Checkout3 from 'modules/Checkout/Checkout3'
import useCartContext from 'components/Cart/useCartContext'
import useUserContext from 'components/User/useUserContext'

const Checkout = ({history}) => {
  const {t} = useTranslation()
  const {cart, cartDispatch} = useCartContext()
  const {user} = useUserContext()
  const [currentStep, setCurrentStep] = useState(user ? 1 : 0)

  const [billingInfo, setBillingInfo] = useState(user?.customerProfile?.billingInfo)

  const next = _ => setCurrentStep(s => s < 3 ? s + 1 : 3)
  const back = _ => setCurrentStep(s => s > 0 ? s - 1 : 0)

  return (
    <>
      <header>
        <AppHeaderCheckout/>
      </header>

      <section>
        <div id='checkout'>
          <CheckoutSteps t={t} current={currentStep}/>

          {currentStep === 0 ? (
            <Checkout0 t={t} next={next}/>
          ) : currentStep === 1 ? (
            <Checkout1 t={t} next={next} cart={cart} cartDispatch={cartDispatch} user={user} history={history}/>
          ) : currentStep === 2 ? (
            <Checkout2 t={t} next={next} back={back} billingInfo={billingInfo} setBillingInfo={setBillingInfo}/>
          ) : currentStep === 3 ? (
            <Checkout3 t={t} back={back} billingInfo={billingInfo}/>
          ) : ''}
        </div>
      </section>
    </>
  )
}

export default Checkout
